import PropTypes from "prop-types";
import { AbstractApisClient } from "./apis";
import { PROJECT_NAME } from "./constants";
import UrlResolver from "./UrlResolver";
export const AppStatePropType = PropTypes.shape({
  auth: PropTypes.object,
  user: PropTypes.object
});
export const ApisPropType = PropTypes.instanceOf(AbstractApisClient);
export const UrlResolverPropType = PropTypes.instanceOf(UrlResolver);
export const ProjectNamePropType = PropTypes.oneOf(Object.values(PROJECT_NAME));
export const UrlParamsPropType = PropTypes.shape({
  protocol: PropTypes.string,
  domain: PropTypes.string,
  gcpEnv: PropTypes.string,
  dpdEnv: PropTypes.string
});